import { LeagueGameRespType } from 'types/league/leagueGame'
import { create } from 'zustand'

const leagueGamesStoreStates = (set: any) => ({
  addGameModal: false,
  setAddGameModal: (state: boolean) =>
    set(() => ({
      addGameModal: state,
    })),
  selectGameModal: false,
  setSelectGameModal: (state: boolean) =>
    set(() => ({
      selectGameModal: state,
    })),
  addScoreModal: false,
  setAddScoreModal: (state: boolean) =>
    set(() => ({
      addScoreModal: state,
    })),
  editTimeModal: false,
  setEditTimeModal: (state: boolean) =>
    set(() => ({
      editTimeModal: state,
    })),
  editFieldModal: false,
  setEditFieldModal: (state: boolean) =>
    set(() => ({
      editFieldModal: state,
    })),
  selectGameForLogModal: false,
  setSelectGameForLogModal: (state: boolean) =>
    set(() => ({
      selectGameForLogModal: state,
    })),
  selectGameForLiveLogModal: false,
  setSelectGameForLiveLogModal: (state: boolean) =>
    set(() => ({
      selectGameForLiveLogModal: state,
    })),
  enterLogModal: false,
  setEnterLogModal: (state: boolean) =>
    set(() => ({
      enterLogModal: state,
    })),
  liveLogModal: false,
  setLiveLogModal: (state: boolean) =>
    set(() => ({
      liveLogModal: state,
    })),

  //data sets
  selectedGame: null,
  setSelectedGame: (state: LeagueGameRespType) => {
    set(() => ({
      selectedGame: state,
    }))
  },
})

export const leagueGamesStore = create(leagueGamesStoreStates)
